/**
 * Footer Image Stateless Component
 */
import { GetBrandsLogosByMerchantResponse } from "@kushki/js/lib/types/get_brands_logos_by_merchant_response";
import { CardBrandEnum } from "containers/Card/store/CardBrandEnum";
import * as React from "react";

/**
 * FooterComponent awesome icons
 */

export class FooterImageComponent extends React.Component<{
  icons: GetBrandsLogosByMerchantResponse[];
}> {
  public iconsPath: GetBrandsLogosByMerchantResponse[] = [];

  private cardBrandsOrder: string[] = [
    CardBrandEnum.VISA,
    CardBrandEnum.MASTERCARD,
    CardBrandEnum.AMEX,
    CardBrandEnum.CARNET,
  ];

  constructor(props: { icons: GetBrandsLogosByMerchantResponse[] }) {
    super(props);

    props.icons.forEach((iconBrand: GetBrandsLogosByMerchantResponse) => {
      this.iconsPath.push(iconBrand);
    });

    this.iconsPath = this.sortIconPathByCardBrandsOrder();
  }

  public render(): React.ReactNode {
    return (
      <>
        <div className="icon-container section">
          {this.iconsPath.map(
            (icon: GetBrandsLogosByMerchantResponse, index: number) => (
              <img
                key={index}
                src={icon.url}
                alt={icon.brand}
                className="imageFooter"
              />
            )
          )}
        </div>
      </>
    );
  }

  private sortIconPathByCardBrandsOrder(): GetBrandsLogosByMerchantResponse[] {
    const sortedIconPath: GetBrandsLogosByMerchantResponse[] = [];

    this.cardBrandsOrder.forEach((cardBrand: string) => {
      const iconBrandFound:
        | GetBrandsLogosByMerchantResponse
        | undefined = this.iconsPath.find(
        (card: GetBrandsLogosByMerchantResponse) => card.brand === cardBrand
      );

      if (iconBrandFound !== undefined) sortedIconPath.push(iconBrandFound);
    });

    this.iconsPath
      .filter((iconPath: GetBrandsLogosByMerchantResponse) => {
        const cardBrandNotSorted:
          | string
          | undefined = this.cardBrandsOrder.find(
          (cardBrand: string) => cardBrand === iconPath.brand
        );

        return cardBrandNotSorted === undefined;
      })
      .forEach((iconBrandNotSorted: GetBrandsLogosByMerchantResponse) => {
        sortedIconPath.push(iconBrandNotSorted);
      });

    return sortedIconPath;
  }
}



// WEBPACK FOOTER //
// ./src/components/UI/FooterImageComponent/FooterImageComponent.tsx